import { pushMessage, clearMessages } from './messages.actions';
import {
  clearErrorMessages,
  clearOnlyErrorMessages,
  resetErrorMessagesWith,
  removeSingleErrorMessage,
  pushServerErrorMessage,
  removeServerErrorMessage,
  tryAgainClicked,
  pushSectionError,
  clearSectionErrors,
  clearSectionErrorsAndErrorMessages,
  pushSectionErrorToErrorMessage,
} from './error-messages.actions';

export {
  RESET_ERROR_MESSAGE_WITH,
  CLEAR_ERROR_MESSAGES,
  CLEAR_ONLY_ERROR_MESSAGES,
  REMOVE_SINGLE_ERROR_MESSAGE,
  TRY_AGAIN_CLICKED,
  REMOVE_SERVER_ERROR_MESSAGE,
  PUSH_SECTION_ERROR,
  PUSH_SECTION_ERROR_TO_ERROR_MESSAGE,
  CLEAR_SECTION_ERRORS,
  CLEAR_SECTION_ERRORS_AND_ERROR_MESSAGES,
} from './error-messages.actions';

export { PUSH_MESSAGE, CLEAR_MESSAGES } from './messages.actions';

export { PUSH_PAGE_MESSAGES } from './page-messages.actions';

export const messagesActions = {
  pushMessage,
  clearMessages,
};
export const errorMessagesActions = {
  clearErrorMessages,
  clearOnlyErrorMessages,
  removeSingleErrorMessage,
  resetErrorMessagesWith,
  pushServerErrorMessage,
  removeServerErrorMessage,
  tryAgainClicked,
  pushSectionError,
  clearSectionErrors,
  clearSectionErrorsAndErrorMessages,
  pushSectionErrorToErrorMessage,
};
